import { createSlice } from "@reduxjs/toolkit";
import {
  fetchContraList,
  createOrUpdateContra,
  deleteContra,
  fetchAccountsForContra,
  fetchContraCode
} from "./contraThunks";

const contraSlice = createSlice({
  name: "contra",
  initialState: {
    contraList: [],
    accounts: [],
    contraCode: "",
    loading: false,
    error: null,
    successMessage: null,
    selectedContra: null,
    isEditContra: false,
  },
  reducers: {
    resetContraStatus: (state) => {
      state.successMessage = null;
    },
    setSelectedContra: (state, action) => {
      state.selectedContra = action.payload;
    },
    setIsEditContra: (state, action) => {
      state.isEditContra = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContraList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchContraList.fulfilled, (state, action) => {
        state.loading = false;
        state.contraList = action.payload;
      })
      .addCase(createOrUpdateContra.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteContra.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(fetchAccountsForContra.fulfilled, (state, action) => {
        state.accounts = action.payload;
      })
      .addCase(fetchContraCode.fulfilled, (state, action) => {
        state.contraCode = action.payload;
      });
  },
});

export const { resetContraStatus, setSelectedContra, setIsEditContra } =
  contraSlice.actions;
export default contraSlice.reducer;
